import { render, staticRenderFns } from "./LimitedHeaderColumnKanban.vue?vue&type=template&id=1a58133c&"
import script from "./LimitedHeaderColumnKanban.vue?vue&type=script&lang=js&"
export * from "./LimitedHeaderColumnKanban.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports